//export const BaseUrl ="https://dev.vadakkekaraapps.com/api/v1"
//export const API_WS_ROOT = 'wss://dev.vadakkekaraapps.com/cable'
export const BaseUrl = process.env.REACT_APP_BASE_URL
export const API_WS_ROOT = process.env.REACT_APP_API_WS_ROOT;

